import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

import PaymentManagement from "@/views/AccountView/PaymentManagement.vue";
import FeeTypeManagement from "@/views/AccountView/FeeTypeManagement.vue";

const accountMenu = {
  path: "/accounts",
  component: DashboardLayout,
  redirect: "/accounts/payments",
  name: "accounts",
  children: [
    {
      path: "payments",
      name: "account-payment",
      components: { default: PaymentManagement },
      meta: {
        requiresAuth: true,
        requiredRoles: ["content", 'master'],
        title: "topnav.payment_management",
      },
    },
    {
      path: "fee-types",
      name: "account-fee-type",
      components: { default: FeeTypeManagement },
      meta: {
        requiresAuth: true,
        requiredRoles: ["content", 'master'],
        title: "topnav.fee_type_management",
      },
    },
  ],
};

export default accountMenu;
